"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPath = void 0;
function toPath(points) {
    return points.reduce((acc, c) => {
        const arr = Array.isArray(c) ? c : [c.x, c.y];
        const [x, y] = arr.map((v) => v.toFixed(2));
        if (!acc)
            return `M${x} ${y}`;
        return acc.concat(`L${x} ${y}`);
    }, "")
        .concat('Z');
}
exports.toPath = toPath;
//# sourceMappingURL=point.js.map